import { safeDefine } from "../../registration/safe-define.js";
import { MenuContentElement } from "../../ui/menu/content.js";
//#region src/define/ui/menu-content.ts
safeDefine(MenuContentElement);
//#endregion

//# sourceMappingURL=menu-content.js.map